export const attestationsABI = [
    {
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'issuer', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'AttestationCompleted',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'value', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'AttestationExpiryBlocksSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'issuer', internalType: 'address', type: 'address', indexed: true },
            {
                name: 'attestationRequestFeeToken',
                internalType: 'address',
                type: 'address',
                indexed: false,
            },
        ],
        name: 'AttestationIssuerSelected',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'token', internalType: 'address', type: 'address', indexed: true },
            { name: 'value', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'AttestationRequestFeeSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'attestationsRequested', internalType: 'uint256', type: 'uint256', indexed: false },
            {
                name: 'attestationRequestFeeToken',
                internalType: 'address',
                type: 'address',
                indexed: false,
            },
        ],
        name: 'AttestationsRequested',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'fromAccount', internalType: 'address', type: 'address', indexed: true },
            { name: 'toAccount', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'AttestationsTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'value', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'MaxAttestationsSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address', indexed: true }],
        name: 'RegistrySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'value', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'SelectIssuersWaitBlocksSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'approver', internalType: 'address', type: 'address', indexed: true },
            { name: 'indentifier', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'from', internalType: 'address', type: 'address', indexed: false },
            { name: 'to', internalType: 'address', type: 'address', indexed: false },
            { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
        ],
        name: 'TransferApproval',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'token', internalType: 'address', type: 'address', indexed: true },
            { name: 'amount', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'Withdrawal',
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'attestationExpiryBlocks',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'attestationRequestFees',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'isOwner',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'maxAttestations',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: '', internalType: 'address', type: 'address' },
            { name: '', internalType: 'address', type: 'address' },
        ],
        name: 'pendingWithdrawals',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'registry',
        outputs: [{ name: '', internalType: 'contract IRegistry', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'selectIssuersWaitBlocks',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address' }],
        name: 'setRegistry',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: '', internalType: 'address', type: 'address' },
            { name: '', internalType: 'bytes32', type: 'bytes32' },
        ],
        name: 'transferApprovals',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'registryAddress', internalType: 'address', type: 'address' },
            { name: '_attestationExpiryBlocks', internalType: 'uint256', type: 'uint256' },
            { name: '_selectIssuersWaitBlocks', internalType: 'uint256', type: 'uint256' },
            { name: '_maxAttestations', internalType: 'uint256', type: 'uint256' },
            { name: 'attestationRequestFeeTokens', internalType: 'address[]', type: 'address[]' },
            { name: 'attestationRequestFeeValues', internalType: 'uint256[]', type: 'uint256[]' },
        ],
        name: 'initialize',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'revoke',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
        name: 'withdraw',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'account', internalType: 'address', type: 'address' },
        ],
        name: 'getUnselectedRequest',
        outputs: [
            { name: '', internalType: 'uint32', type: 'uint32' },
            { name: '', internalType: 'uint32', type: 'uint32' },
            { name: '', internalType: 'address', type: 'address' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'account', internalType: 'address', type: 'address' },
        ],
        name: 'getAttestationIssuers',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'account', internalType: 'address', type: 'address' },
        ],
        name: 'getAttestationStats',
        outputs: [
            { name: '', internalType: 'uint32', type: 'uint32' },
            { name: '', internalType: 'uint32', type: 'uint32' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'identifiersToLookup', internalType: 'bytes32[]', type: 'bytes32[]' }],
        name: 'batchGetAttestationStats',
        outputs: [
            { name: '', internalType: 'uint256[]', type: 'uint256[]' },
            { name: '', internalType: 'address[]', type: 'address[]' },
            { name: '', internalType: 'uint64[]', type: 'uint64[]' },
            { name: '', internalType: 'uint64[]', type: 'uint64[]' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'account', internalType: 'address', type: 'address' },
            { name: 'issuer', internalType: 'address', type: 'address' },
        ],
        name: 'getAttestationState',
        outputs: [
            { name: '', internalType: 'uint8', type: 'uint8' },
            { name: '', internalType: 'uint32', type: 'uint32' },
            { name: '', internalType: 'address', type: 'address' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'account', internalType: 'address', type: 'address' },
        ],
        name: 'getCompletableAttestations',
        outputs: [
            { name: '', internalType: 'uint32[]', type: 'uint32[]' },
            { name: '', internalType: 'address[]', type: 'address[]' },
            { name: '', internalType: 'uint256[]', type: 'uint256[]' },
            { name: '', internalType: 'bytes', type: 'bytes' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
        name: 'getAttestationRequestFee',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getMaxAttestations',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'identifier', internalType: 'bytes32', type: 'bytes32' }],
        name: 'lookupAccountsForIdentifier',
        outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'account', internalType: 'address', type: 'address' },
            { name: 'expected', internalType: 'uint32', type: 'uint32' },
        ],
        name: 'requireNAttestationsRequested',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'token', internalType: 'address', type: 'address' },
            { name: 'fee', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setAttestationRequestFee',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_attestationExpiryBlocks', internalType: 'uint256', type: 'uint256' }],
        name: 'setAttestationExpiryBlocks',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_selectIssuersWaitBlocks', internalType: 'uint256', type: 'uint256' }],
        name: 'setSelectIssuersWaitBlocks',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_maxAttestations', internalType: 'uint256', type: 'uint256' }],
        name: 'setMaxAttestations',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'identifier', internalType: 'bytes32', type: 'bytes32' },
            { name: 'account', internalType: 'address', type: 'address' },
            { name: 'v', internalType: 'uint8', type: 'uint8' },
            { name: 'r', internalType: 'bytes32', type: 'bytes32' },
            { name: 's', internalType: 'bytes32', type: 'bytes32' },
        ],
        name: 'validateAttestationCode',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
];
